import React from "react";

const OurJourney = ({journeyData}) => {
  return (
    <div className="our-journey">
      <h6 className="about-sub-heading mb-2 text-center">Who We Serve</h6>

      <div className="row g-5 team-journey-card">
        {journeyData.map((item, index) => (
          <div className="col-sm-6 col-md-6 col-lg-3" key={index}>
            <div className="journey-box h-100 shadow-sm overflow-hidden p-4">
              <div className="d-flex justify-content-center">
                <img src={item.img} className="img-fluid" alt={item.title || "Our journey"} />
              </div>

              <div className="journey-box-content">
                <h6 className="hero-sub-text">{item.title}</h6>
                <p className="about-sub-content mt-2">{item.desc}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurJourney;
